<template>
	<div>
		<nav-bar type="dark"></nav-bar>
		<b-container fluid class="app">
			<b-row>
				<b-col lg="7" md="12" class="mb-3">
					<b-card-group>
            <b-card sub-title="Dados do Cliente" border-variant="secundary">
              <span class="badge badge-danger float-right" v-show="contact.isAgenda">AGENDAMENTO</span>

              <crm-tabs :items="contacts" :tabName="'nome'" @changedTab="changeContact"></crm-tabs>

							<b-row>
                <b-col lg="6" md="6" sm="6">
                  <b-form-group id="g-id-arautos" label="ID Arautos" label-for="id_arautos" description="">
                    <b-form-input size="sm" :value="contact.codCad" id="id_arautos" type="text" placeholder="ID Arautos" maxlength="80" readonly></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col lg="6" md="6" sm="6">
                  <b-form-group id="g-cob-arautos" label="Cob. Arautos" label-for="cob_arautos" description="">
                    <b-form-input size="sm" :value="contact.codCob" id="cob_arautos" type="text" placeholder="Cob. Arautos" maxlength="80" readonly></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

							<b-row>

                <b-col lg="2" md="2" sm="4">
                  <b-form-group id="g-tratamento" label="Tratamento" label-for="nome_contato" description="">
                    <b-form-input size="sm" :value="tratamento.formaTratamento" id="tratamento" type="text" maxlength="80" readonly></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col lg="10" md="10" sm="8">
                  <b-form-group id="g-nome" label="Nome" label-for="nome_contato" description="">
                    <b-form-input size="sm" v-model="contact.nome" id="nome_contato" type="text" placeholder="Nome" maxlength="80"></b-form-input>
                  </b-form-group>
                </b-col>

              </b-row>

							<b-row>
								<b-col lg="6" md="6" sm="6">
									<b-form-group id="g-telefone" label="Telefone" label-for="telefone">
										<div class="input-group">

											<input @keyup.enter="onClickDialOtherTel(contact.telefone)" v-model="contact.telefone" id="telefone" type="text" class="form-control form-control-sm" />

                      <div class="input-group-prepend">
                        <div class="btn-group">
                          <b-btn size="sm" @click.stop="onClickDialOtherTel(contact.telefone)" v-b-popover.hover.bottom="'Discar'" variant="success" v-show="hasIntegration" ><i class="fa fa-phone"> </i></b-btn>
                          <b-btn size="sm" @click.stop="onClickAddTelefoneToContact(contact.telefone)" :disabled="!contact.id" v-b-popover.hover.bottom="'Adicionar Telefone'" variant="dark"><i class="fa fa-plus"></i></b-btn>
                          <b-btn :disabled="!contact.id" v-b-toggle.others-tel v-b-popover.hover.bottom="'Demais telefones do contato'" variant="info"><i class="fa fa-bars"></i></b-btn>
                        </div>
											</div>

										</div>
									</b-form-group>
								</b-col>

								<!-- <b-col lg="6" md="6" sm="6">
									<b-form-group id="g-email" label="E-mail" label-for="email">
										<b-form-input size="sm" readonly v-model="contact.email" id="email" type="email"></b-form-input>
									</b-form-group>
								</b-col> -->

                <b-col lg="6" md="6" sm="6">
                  <label class="form-label">E-mail</label>
                  <div class="input-group">
                    <input type="text" class="form-control form-control-sm" @change="changeMail" v-model="contact.email">
                    <div class="input-group-prepend" v-show="showDisplaySendMail">
                      <button class="btn btn-outline-info btn-sm" @click.prevent="onClickSendMail(contact.email)" :disabled="emailHasSend || emailLoading">{{ emailLoading ? 'Enviando...' : 'Enviar e-mail' }}</button>
                    </div>
                  </div>
                </b-col>

							</b-row>

              <div class="row" v-show="showDisplaySendMail">
                <div class="offset-md-7 col-md-5">
                  <div class="text-right mt-2">
                    <input v-model="receberInformativo" @change="changeStatus(receberInformativo)" type="checkbox" class="form-check-input" id="checkEnviarInformativo" :disabled="emailHasSend">
                    <label class="form-check-label" for="checkEnviarInformativo">Receber informativo via e-mail</label>
                  </div>
                </div>
              </div>

              <hr>

							<b-collapse id="others-tel" class="mt-2">
								<b-card sub-title="Demais Telefones do Contato">
									<b-row>
										<b-col lg="12" md="12" sm="12">
											<table class="table table-striped table-hover">
												<thead>
													<tr>
														<th>Telefone</th>
														<th class="text-center">Retorno/Tabulação</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="tel in contact.telefones" :key="tel.id" @dblclick="onClickDialOtherTel(tel)">
														<td>{{tel.ddd}} {{tel.telefone}}</td>
														<td class="text-center">
															<span :class="tel.tabulacao ? 'badge badge-pill badge-info text-white' : ''">{{ getTabulacaoDescription(tel.tabulacao) }}</span>
														</td>
													</tr>
												</tbody>
											</table>
                      <small class="text-info">* Duplo clique sobre telefone para discar.</small>
										</b-col>
									</b-row>
								</b-card>
							</b-collapse>

							<b-row>
								<b-col lg="6" md="5" sm="6">
									<b-form-group id="g-documento" label="CPF / CNPJ" label-for="documento">
										<input readonly v-model="contact.documento" id="documento" type="text" placeholder="" class="form-control form-control-sm" />
									</b-form-group>
								</b-col>

								<b-col lg="4" md="4" sm="4">
									<b-form-group id="g-nascimento" label="Nascimento" label-for="nascimento">
										<b-form-input size="sm" readonly v-model="contact.dtNascimento" id="nascimento" type="text"></b-form-input>
									</b-form-group>
								</b-col>

								<b-col lg="2" md="3" sm="2">
									<b-form-group id="g-sexo" label="Sexo" label-for="sexo">
										<!-- <b-form-input size="sm" readonly v-model="contact.sexo" id="sexo" type="text"></b-form-input> -->
                    <select class="form-control form-control-sm" size="sm" id="sexo" v-model="contact.sexo">
                      <option value=""></option>
                      <option value="F">F</option>
                      <option value="M">M</option>
                    </select>
									</b-form-group>
								</b-col>

							</b-row>

							<b-row>

                <b-col sm="12" md="3" lg="3">
                  <b-form-group id="g-cep" label="CEP" label-for="cep">
										<div class="input-group">

                      <input size="sm" v-model="contact.cep" v-mask="'#####-###'" id="cep" type="text" class="form-control form-control-sm" @keyup.enter="fetchCEP(contact)" />

                      <div class="input-group-prepend">
                        <b-btn size="sm" v-b-popover.hover.bottom="'Pesquisar CEP'" variant="info" @focus="fetchCEP(contact)" @click="fetchCEP(contact)">
                          <i class="fa" :class="{'fa-search': !loadingCEP, 'fa-spinner fa-spin': loadingCEP}"></i>
                        </b-btn>
											</div>

										</div>

                  </b-form-group>
                </b-col>

                <b-col sm="12" md="7" lg="7">
                  <b-form-group id="g-logradouro" label="Endereço">
                    <b-row>
											<b-col lg="12" md="12" sm="12" class="ml-0 mr-0">
												<b-form-input size="sm" v-model="contact.logr" id="logradouro" md="3" />
											</b-col>
										</b-row>
									</b-form-group>
								</b-col>

                <b-col sm="12" md="5" lg="2">
                  <b-form-group id="g-numero" label="N°">
                    <b-row>
											<b-col lg="12" md="12" sm="12" class="ml-0 mr-0">
												<b-form-input size="sm" v-model="contact.numero" v-mask="'##########'" id="logradouro" md="3" maxlength="80"/>
											</b-col>
										</b-row>
									</b-form-group>
								</b-col>

							</b-row>

							<b-row>

                <b-col xs="12" lg="6">
                  <b-form-group id="g-complemento" label="Complemento" label-for="complemento">
                    <b-form-input size="sm" v-model="contact.compl" id="complemento" type="text" maxlength="50" />
                  </b-form-group>
                </b-col>

                <b-col xs="12" lg="6">
									<b-form-group id="g-bairro" label="Bairro" label-for="bairro">
										<b-form-input size="sm" v-model="contact.bairro" id="bairro" type="text" maxlength="60"></b-form-input>
									</b-form-group>
								</b-col>

                <b-col xs="6" lg="2">
                  <b-form-group id="g-uf" label="UF" label-for="uf">
                    <!-- <b-form-input size="sm" v-model="contact.estado" id="uf" type="text" /> -->
                    <select class="form-control form-control-sm" v-model="contact.estado">
                        <option value=""></option>
                        <option v-for="(uf, indexUF) in ufs" :key="indexUF" :value="uf">{{uf}}</option>
                    </select>

                  </b-form-group>
                </b-col>

                <b-col xs="12" lg="5">
                  <b-form-group id="g-cidade" label="Cidade" label-for="cidade">
                    <b-form-input size="sm" v-model="contact.cidade" id="cidade" type="text" maxlength="60" />
                  </b-form-group>
                </b-col>

                <b-col cols="12">
                  <b-form-group label="Informações">
                    <textarea class="form-control form-control-sm" rows="3" readonly :value="contact.outrasInformacoes" ></textarea>
                  </b-form-group>
                </b-col>

              </b-row>
            </b-card>
					</b-card-group>
				</b-col>

				<b-col sm="12" md="12" lg="5">

					<b-row>

            <b-col md="6" lg="12" sm="6" class="mb-2">
              <b-card>
                <b-row>
                  <b-col xs="12" sm="12" md="6" lg="6">
                    <b-button size="sm" @click="transferData(contact)" variant="success" :disabled="loading" class="mt-4">
                      <i class="fa fa-id-card-o"></i> PREENCHER ASSINATURA
                    </b-button>
                  </b-col>

                  <b-col xs="12" sm="12" md="6" lg="6">
                    <b-button size="sm" @click="onOpenModalIndicacao(contact)" variant="info" :disabled="loading" class="mt-4">
                      <i class="fa fa-id-card"></i> CADASTRAR INDICAÇÃO
                    </b-button>
                  </b-col>

                  <b-col xs="12" sm="12" md="6" lg="6" class="mt-2" v-show="hasRecebeuRevista" >
                    <label for="tabulacao">Recebeu a revista?</label>
                    <select :disabled="disabledRecebeuRevista" class="form-control form-control-sm" v-model="contact.recebeuRevista">
                      <option value=""></option>
                      <option value="SIM">SIM</option>
                      <option value="NAO">NAO</option>
                    </select>
                  </b-col>

                </b-row>

              </b-card>
            </b-col>

						<b-col md="6" lg="12" sm="6" class="mb-2">
							<b-card sub-title="Agendamento" header-bg-variant="warning" :border-variant="borderVariantSchedule" header-text-variant="white">

								<b-form-group id="g-date-hora" label-for="agenda">
									<b-row>
										<b-col>
											<span>Data</span>
                      <vue-datepicker-local inputClass="form-control" style="display:block" :local="localDatepicker" :clearable="true" format="DD/MM/YYYY" v-model="agenda.data"/>
										</b-col>
										<b-col>
											<span>Hora</span>
											<input v-mask="'##:##:##'" @keyup.enter="onClickListenerOnSchedule()" v-model="agenda.hora" text="time" id="hora" class="form-control form-control-sm"/>
										</b-col>
									</b-row>
								</b-form-group>


								<b-form-group id="g-date-hora" label-for="agenda">
                  <b-form-group>
                    <b-form-radio-group id="agenda.tipo" v-model="agenda.tipo" :options="[{ text: 'PF', value: 'PF' }, { text: 'NE', value: 'NE' }]" name="radio-options" ></b-form-radio-group>
                  </b-form-group>
								</b-form-group>

								<b-form-group label="Observação" id="g-obs-agenda" v-if="hasSchedule">
									<b-form-textarea v-model="agenda.obs" :rows="1" />
								</b-form-group>


								<b-button size="sm" :disabled="(!contact.id || ligacaoEmCurso)" type="submit" variant="outline-secondary" @click="onClickListenerOnSchedule()">
									<i class="fa fa-calendar-check-o"></i> CONFIRMAR AGENDA</b-button>

                <b-button size="sm" variant="info" v-if="hasSchedule" @click="_onClickShowModal('modalAgenda')" class="pull-right">
                  <i class="fa fa-calendar"></i> VER AGENDA
                  <b-badge v-if="contatosAgendado.length > 0" variant="badge badge-pill badge-dark">{{contatosAgendado.length}}</b-badge>
                </b-button>

							</b-card>
						</b-col>

						<b-col md="6" lg="12" sm="6" class="mb-2">
							<b-card header-bg-variant="dark" border-variant="secundary" header-text-variant="white" text-variant="dark">

								<b-row>
									<b-col>
                    <label for="tabulacao">Tabulação</label>
                    <select :disabled="!contact.id" id="tabulacao" class="form-control form-control-sm" v-model="tabulacao.tabulacao" @change="tabulacao.motivo = null">
                      <option value=""></option>
                      <template v-for="tipo in getTabulacoesTipos">
												<optgroup :key="tipo" :label="tipo">
													<template v-for="tabulacao in getTabulacoes(tipo)">
                            <option :key="tabulacao.id" :value="tabulacao">{{ tabulacao.tabulacao }}</option>
													</template>
												</optgroup>
                      </template>
                    </select>
									</b-col>

									<b-col>
                    <label for="motivo_providencia">{{ this.hasProvidencia ? 'Providência' : 'Motivo' }}</label>
                    <select :disabled="!contact.id || getMotivos.length <= 0" id="motivo_providencia" class="form-control form-control-sm" v-model="tabulacao.motivo">
                      <option value=""></option>
                        <option v-for="motivo in getMotivos" :key="motivo.id" :value="motivo.id">{{ motivo.motivo }}</option>
                    </select>
									</b-col>

								</b-row>

                <b-row>
                  <b-col class="mt-2">
                    <b-form-group label="Observação" id="g-obs-contato" v-if="hasProvidencia">
                      <b-form-textarea :rows="2" v-model="contact.newObs" />
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="mt-2">
                    <b-button size="sm" block @click="onClickListenerRefused" :disabled="!tabulacaoHasTelefonia" variant="outline-info">TABULAR TELEFONE <i class="fa fa-check-square-o"></i></b-button>
                  </b-col>

                  <b-col class="mt-2">
                    <b-button size="sm" block @click="onClickListenerFinishContact" variant="outline-success">{{ this.contatoTabulado ? 'FINALIZAR' : 'TABULAR' }} CONTATO <i class="fa fa-check"></i></b-button>
                  </b-col>
                </b-row>

							</b-card>
						</b-col>

            <modal name="modalAgendaEdit" class="z-index-full" height="auto" :min-height="350" :resizable="true" scrollable :reset="true" :adaptive="true" >
              <schedule-edit :schedule="scheduleEdit" @cancel="_onClickHideModal('modalAgendaEdit')" @confirm="_updateListSchedules" />
            </modal>

            <modal name="modalAgenda" class="z-index-full" :draggable="true" width="90%" height="auto" :min-height="500"
              :min-width="300" :resizable="true" scrollable :reset="true" :adaptive="true" >

              <schedule-list :schedules="contatosAgendado" @editSchedule="editSchedule" />
            </modal>

					</b-row>

				</b-col>

			</b-row>

		</b-container>

		<pabx-card :agent="getMatricula" @onEvent="onEventListenerPABX" v-if="hasIntegration" ></pabx-card>
	</div>
</template>

<script>
const rexExpMail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/

import pabxStatus from "../Utils/PabxStatus";
import localDatepicker from "../Utils/VueDatepickerLocal.js";
import UFs from "../Utils/UFs.json";

import { contactService, refusesService, scheduleService, callidLogService, utilsService, mailService } from "../service";
import bilhetagemController from "../controllers/BilhetagemController";
import { GET_MAILINGS } from '../graphql/mailings.graphql'

import NavBar from "./NavBar/NavBar.vue";
import PabxCard from "./shared/PabxCard.vue";
import ScheduleEdit from "./shared/Schedule/ScheduleEdit.vue";
import ScheduleList from "./shared/Schedule/ScheduleList.vue";

import FormVenda from "./campaigns/FormVenda.vue";

import CRMTabs from "./custom/Tabs.vue";

import gql from 'graphql-tag'
import { mapState } from "vuex";

export default {
  name: "Operacional",

  components: {
    NavBar,
    ScheduleEdit,
    ScheduleList,
    PabxCard,
    FormVenda,
    "crm-tabs": CRMTabs
  },

  data: () => ({
    loading: false,
    loadingCEP: false,
    localDatepicker,
    from: "",
    fromId: 0,
    telefoneId: 0,
    contatoTabulado: false,
    rediscagem: false,
    ligacaoEmCurso: false,

    tabulacao: { tabulacao: {}, motivo: null },
    tabulacoes: [],

    tratamento: { id: null, formaTratamento: '' },

    contact: {},
    originalContact: {},

    proposta: {},

    agenda: { hora: "", data: new Date(), obs: "", tipo: 'PF' },

    receberInformativo: true,
    emailLoading: false,

    scheduleEdit: {},
    contatosAgendado: [],
    mailings: []
  }),

  beforeDestroy(){
    this.$bus.$off('modal-open-if-operacional')
  },

  mounted() {
    if (!this.getUser.token) {
      this.$router.push("/");
    }

    this.fetchRefuses();
    this.localDatepicker = localDatepicker;

    setTimeout(() => {
      if(!this.hasIntegration){
        this.nextContact()
      }
    }, 2000)

    this._onSubscribeOnFinish()

    this.$bus.$on("modal-open-if-operacional", proposta => {
      this.$bus.$emit('modal-open', {
        name: 'formVenda',
        title: 'FICHA DE ASSINATURA',
        nextEvent: {
          event: "proposta-retorno",
          data: proposta,
          delay: 550
        }
      })
    })

    this.$store.commit('SET_RECEBER_INFORMATIVO', this.showDisplaySendMail)
    if(this.hasContact && !this.contact.id) this.reloadData(this.contact)

  },

  apollo: {

    fetchPublicos: {
      query: GET_MAILINGS,

      variables(){
        return {
          campanhaId: this.getUser.campanhaId
        }
      },

      manual: true,

      result({ data }) {
        const { mailings } = data
        this.mailings = mailings || []
      }
    },

    getTratamento: {
      query: gql`
        query getTratamento ($id: Int!) {
          tratamento(id: $id) {
            id
            codTratamento
            descTratamento
            formaTratamento
          }
        }
      `,

      skip(){
        return !this.contact.idTratamento
      },

      manual: true,

      variables(){
        return {
          id: this.contact.idTratamento
        }
      },

      result({ data }){
        const { tratamento } = data
        this.tratamento = tratamento
      }
    }

  },

  computed: {

    ...mapState({
      contacts: state => state.contact || [],

      getUser: state => state.user,

      campanha: state => state.user.campanha,

      mail: state => state.mail,

      emailHasSend: state => state.mail.emailHasSend,

      hasProvidencia(){
        return this.getUser.providencia === 1
      },

    }),

    ufs() {
      return UFs
    },

    hasIntegration(){
      return this.$store.getters.hasIntegration
    },

    borderVariantSchedule() {
      return this.contact.agenda ? "danger" : "";
    },

    getMatricula() {
      return this.getUser.matricula;
    },

    getMotivos(){
      const [ providencias ] = this.tabulacoes.filter(tabulacao => tabulacao.id === this.tabulacao.tabulacao.id).map(tabulacao => tabulacao.motivos)
      return providencias ? providencias : []
    },

    getTabulacoesTipos(){
      let types = this.tabulacoes
        .filter(tabulacao => !tabulacao.interno)
        .map(tabulacao => tabulacao.tipo)
        .filter(tipo => this.getTabulacoes(tipo).length > 0)


      return Array.from(new Set(types))
    },

    disabledActions() {
      return !this.contact.id || !this.contatoTabulado || this.loading;
    },

    enableActionRefused() {
      return (this.contact.id && (this.tabulacao.tabulacao.id || this.tabulacao.tabulacao.id === 0) && !this.ligacaoEmCurso);
    },

    hasSchedule() {
      return this.getUser.agendamento;
    },

    hasContact() {
      return this.$store.getters.hasContact;
    },

    tabulacaoHasTelefonia(){
      const { tabulacao } = this.tabulacao || {}

      if(tabulacao) return tabulacao.tipo === 'TELEFONIA'

      return false
    },

    showDisplaySendMail(){
      return true
    },

    hasRecebeuRevista(){
      return this.mailings
        .filter(mailing => mailing.id == this.contact.mailingId)
        .some(mailing => mailing.recebeuRevista)
    },

    disabledRecebeuRevista(){
      const { recebeuRevista } = this.originalContact
      return recebeuRevista
    }
  },

  methods: {
    changeStatus(value) {
      this.$store.commit('SET_RECEBER_INFORMATIVO', value)
    },

    changeMail(){
      this.$store.commit('SET_RECEBER_INFORMATIVO', true)
      this.$store.commit('SET_MAIL_SEND', false)
    },

    _onSubscribeOnFinish() {
      this.$bus.$on('onFinish', data => {
        if(data.bilhetagem){
          bilhetagemController.add(data.bilhetagem);
        }
        this.contactOnFinish();

        this.$notify({
          title: "Proposta Finalizada.",
          message: "Sua proposta foi salva com sucesso!",
          type: "success",
          offset: 20
        });
      })

    },

    _clearFormSchedule() {
      this.agenda.hora = "";
      this.agenda.data = new Date();
      this.agenda.obs = "";
      this.agenda.tipo = 'PF'
    },

    _clearFormaTratamento(){
      this.tratamento = { id: null, formaTratamento: '' }
    },

    _updateListSchedules(schedule) {
      this._onClickHideModal("modalAgendaEdit");
      this.contatosAgendado = this.contatosAgendado.map(
        item => (schedule.id == item.id ? schedule : item)
      );
    },

    _removeScheduleFromList(schedule) {
      let index = this.contatosAgendado
        .map(item => item.id)
        .indexOf(schedule.id);
      this.contatosAgendado.splice(0, 1);
    },

    _getContactFromSchedule: schedule =>
      contactService.get(schedule.idContato).then(contact => {
        contact.agenda = schedule;
        return contact;
      }),

    _onClickShowModal(modalName) {
      this.$modal.show(modalName);
    },

    _onClickHideModal(modalName) {
      this.$modal.hide(modalName);
    },

    _phoneHasExistsInContacts (phone) {
      return this.contacts.some(conctact => {
        let { telefone } = conctact
        return phone == telefone
      })
    },

    getTabulacoes(tipo) {
      return this.tabulacoes
        .filter(tabulacao => tabulacao.tipo === tipo)
        .filter(tabulacao => {
          if(tabulacao.tipo === 'SUCESSO' && tabulacao.tce === 0) return false
          return true
        })
    },

    getTabulacaoDescription(tabulacaoId){
      return this.tabulacoes.filter(tabulacao => tabulacao.id === tabulacaoId)
        .map(({ tabulacao }) => tabulacao)
        .reduce((next, current) => {
          return next || current
        }, '')
    },

    changeContact(c) {
      bilhetagemController.clean();
      this.loadDataAndCall(c, c.isAgenda || false, false);
    },

    editSchedule(schedule) {
      this.scheduleEdit = Object.assign({}, schedule);

      this._onClickHideModal("modalAgenda");
      this._onClickShowModal("modalAgendaEdit");
    },

    reloadData() {
      let contact = this.$store.state.contact[0];
      this.from = contact.telefone;
      this.loading = false

      this.loadDataAndCall(contact, contact.agenda, false);
      this.fetchSchedules()
        .then(schedules => (this.contatosAgendado = schedules))
        .then(schedules => contact.isAgenda ? this._removeScheduleFromList(contact.agenda) : null);
    },

    nextContact() {
      if ((!this.contact.id && this.contacts.length <= 0) && (this.$store.getters.getPabxStatus == pabxStatus.disponivel || !this.hasIntegration)){
        this.loading = true
        this.fetchSchedules()
          .then(schedules => (this.contatosAgendado = schedules))
          .then(() => this.hasNextScheduleForNow())
          .then(this._getContactFromSchedule)
          .then(result => this.loadDataAndCall(result, true, true))
          .then(_ => this.loading = false)
          .catch(err => {
            this.loading = false
            if (this.getUser.tipoDiscagem !== "PREDITIVO") {
              this.loading = true
              this.fetchNextContact(this.getUser.tipoDiscagem === "POWER");
            }
          });
      }
    },

    hasNextScheduleForNow() {
      return new Promise((resolve, reject) => {
        let scheduleNow = schedule => {

          let timeNow = this.$moment(new Date())
          let date = this.$moment(schedule.data).format("YYYY-MM-DD");
          let dateSchedule = this.$moment(`${date} ${schedule.hora}`);

          return timeNow.isSameOrAfter(dateSchedule);
        };

        let [ schedule ] = this.contatosAgendado
          .filter(scheduleNow)
          .filter((_, index) => index == 0);

        if (!schedule) return reject();

        this.contact.obs = schedule.obs;
        this._removeScheduleFromList(schedule);

        resolve(schedule);
      });
    },

    loadDataAndCall(data, isAgenda = false, dial = false) {
      this.contatoTabulado = false;
      this.contact = data;
      this.contact.isAgenda = isAgenda;
      this.loading = false
      this.agenda.obs = ''

      if (isAgenda && this.contact.agenda) {
        this.agenda.obs = this.contact.agenda.obs;
      }

      if (this.contact.nasc) {
        let date = this.$moment(this.contact.nasc);
        if (date.isValid())
          this.contact.dtNascimento = date.utc().format("DD/MM/YYYY");
      }

      let fromContact = "";
      data.telefones.forEach(item => {
        if (item.tabulacao == "AGENDAMENTO") fromContact = item;
      });

      data.telefones.forEach(item => {
        if (`${item.ddd}${item.telefone}` === this.from) fromContact = item;
      });

      fromContact = fromContact === "" ? data.telefones[0] : fromContact;


      this.telefoneId = fromContact.id;
      this.from = `${fromContact.ddd}${fromContact.telefone}`;
      this.contact.telefone = this.from;

      if (dial && !isAgenda) {
        this.$bus.$emit("doDial", { to: this.from, contactName: this.contact.nome, label: "AGENDAMENTO"});
      }

      if(isAgenda) this.$bus.$emit("doPause", { pause: 9 });

      this.$store.commit("addContact", this.contact);
    },

    fetchSchedules() {
      return scheduleService.get().catch(err => {
        console.log(err);
        Promise.resolve([]);
      });
    },

    fetchRefuses() {
      refusesService.fetch().then(refuses => {
        this.tabulacoes = refuses
      });
    },

    fetchNextContact(clickToDial = false) {
      contactService
        .fetchOneContact()
        .then(contact => {
          this.originalContact = Object.assign({}, contact)
          this.loadDataAndCall(contact, false, clickToDial);
        })
        .catch(err => {
          this.loading = false
          this.$notify({
            title: "Contato.",
            message: err || "Ocorreu um erro. Avise seu supervidor",
            type: "warning",
            offset: 20
          });

          setTimeout(() => { this.nextContact() }, 15000)
        })
    },

    fetchContact(phone) {
      return new Promise((resolve, reject) => {
        if (phone && !this._phoneHasExistsInContacts(phone)) {
          contactService
            .fetch(phone)
            .then(contact => {
              contact.queue = this.lastQueue || "";
              contact.callId = this.lastCallId || "";
              resolve(contact);
            })
            .catch(err => reject(err));
        } else {
          reject({ message: 'Não há telefone para pesquisa / Telefone já carregado' });
        }
      });

      //.then(contact => this.loadAndShowData(contact));
    },

    fetchContactById(id) {
      let contactID = parseInt(id);

      return contactService
        .get(contactID)
        .then(contact => {
          if(!contact || !contact.id) throw new Error('Contato não localizado.')

          contact.queue = this.lastQueue || ''
          contact.callId = this.lastCallId || ''
          return contact;
        })
        .catch(err => this.fetchContact(this.from).then(contact => contact))
    },

    onClickSendMail(mail){
      if(!this.emailHasSend && mail && rexExpMail.test(mail)){
        this.emailLoading = true
        mailService
          .send(mail)
          .then(_ => {
            this.$store.commit('SET_RECEBER_INFORMATIVO', true)
            this.$store.commit('SET_MAIL_SEND', true)

            this.emailLoading = false
          })
          .catch(_ => {
            this.$store.commit('SET_MAIL_SEND', false)
            this.emailLoading = false
          })
      }
    },

    fetchCEP(contact){
      this.loadingCEP = true
      const { cep } = contact
      utilsService.fetchCEP((cep || "").replace(/\D/g, ""))
        .then(correios => {
          this.loadingCEP = false
          if(correios){
            contact.logr = correios.end
            contact.bairro = correios.bairro
            contact.estado = correios.uf
            contact.cidade = correios.cidade
          }
        })
        .catch(_ => {
          this.loadingCEP = false
        })
    },

    onOpenModalIndicacao(contact){
      if (contact.id){
        this.$bus.$emit('modal-open', {
          name: 'formIndicao',
          title: 'FICHA DE INDICAÇÃO',
          extra: { contact : contact }
        })
      }
    },

    transferData(contact) {
      try {
        if(this.hasRecebeuRevista){
          if(!this.contact.recebeuRevista)
            throw new Error(`Informe antes se Recebeu Revista.`)
        }

        this.proposta = JSON.parse(JSON.stringify(contact));
        this.proposta.nasc = this.proposta.dtNascimento;
        let campanha = (this.campanha.toLowerCase().trim()).replace(' ', '_')

        let proposta = JSON.parse(JSON.stringify(this.proposta))

        if (contact.id || this.getUser.vendaAvulsa) {
          this.$bus.$emit('modal-open', {
            name: 'formVenda',
            title: 'FICHA DE ASSINATURA',
            extra: { contact : proposta, tabulacoes: this.tabulacoes }
          })
        }
      } catch(err) {
        this.$alert(err.message, "Finalizar Contato", { confirmButtonText: "OK" });
      }
    },

    onClickAddTelefoneToContact(telefone){
      this.addTelefoneToContact(telefone)
        .then(success => {
          this.$message({ showClose: true, message: "Telefone cadastrado.", type: "success"})
        })
        .catch(err => {
          this.$message({ showClose: true, message: err.message || "Telefone não cadastrado.", type: "warning"})
        })
    },

    addTelefoneToContact(telefone) {
      return new Promise((resolve, reject) => {
        if (this.contact.telefones.length > 0) {
          if(telefone.length < 10) throw new Error('Telefone inválido')

          let tels = this.contact.telefones.filter(obj => {
            return telefone == `${obj.ddd}${obj.telefone}`
          });

          if (tels.length == 0) {
            return contactService
              .addTelefone(this.contact.id, telefone)
              .then(newTelefone => {
                this.telefoneId = newTelefone.id
                this.contact.telefones.push(newTelefone)
                resolve()
              })
              .catch(err => new Error(err));
          } else {
            throw new Error('Telefone já cadastrado para o cliente')
          }
        }
      })
    },

    onClickListenerDial(tel) {
      let telToDial = tel.replace(/\D/g, "").trim();

      this.contact.telefone = telToDial;
      this.from = telToDial;

      this.$bus.$emit("doUnPause", {});

      setTimeout(() => this.$bus.$emit("doDial", {
        to: telToDial,
        contactName: this.contact.nome
        }), 1000);
    },

    onClickDialOtherTel(tel) {
      if (tel == "" || tel == undefined) return false;

      let telefone = typeof tel === "string" ? tel : `${tel.ddd}${tel.telefone}`;

      if (this.ligacaoEmCurso || (this.contact.id && !this.contatoTabulado && telefone != this.from)) {
        let msg = this.ligacaoEmCurso
          ? "Não é possível efetuar chamada enquanto estiver com uma ligação em curso."
          : "Efetue a tabulação do contato antes de prosseguir";

        this.$alert(msg, "Nova Chamada", {
          confirmButtonText: "OK"
        });

        return false;
      }

      this.$confirm(
        `Deseja efetuar nova chamada para o número ${telefone}?`,
        "Nova Chamada",
        { confirmButtonText: "Ligar", cancelButtonText: "Cancelar" }
      ).then(() => {
        this.rediscagem = tel == this.from;

        if (!this.rediscagem) {
          this.telefoneId = tel.id;
        }

        document.getElementById("telefone").value = telefone;
        this.onClickListenerDial(telefone);
      });
    },

    onClickListenerOnSchedule() {
      if (!this.contact.id || this.ligacaoEmCurso) return false;
      if (!this.ligacaoFoiFinalizada()) return false;

      let dataFormatadaPtBR = this.$moment(this.agenda.data).format("DD/MM/YYYY");

      let date = new Date();
      let now = new Date(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`);

      let isValidHour = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])$/.test(this.agenda.hora);

      try {
        if (isNaN(Date.parse(this.agenda.data)) || new Date(this.agenda.data) < now)
          throw new Error("A Data informada não é válida.");

        let diffDays = this.$moment(`${this.agenda.data}`).diff(this.$moment(now), 'days') + 1
        if(diffDays > 20) throw new Error('A Data informada não pode ter um período maior que 20 dias.');

        if (!isValidHour) throw new Error("Hora informada não é válida.");

        this.$confirm(`Confirmar agendamento para ${dataFormatadaPtBR} às ${this.agenda.hora}?`, "Agendamento")
          .then(() => {
            this.tabularTelefone({ telefoneId: this.telefoneId, tabulacaoId: 5, tabulacaoTipo: "INSUCESSO" });

            const agenda = {
              contactId: this.contact.id,
              mailingId: this.contact.mailingId,
              contactName: this.contact.nome,
              telefones: this.contact.telefones,
              telefone: this.from,
              date: this.$moment(this.agenda.data).format("YYYY-MM-DD"),
              time: this.agenda.hora || "00:00:00",
              obs: this.agenda.obs,
              queue: this.contact.queue,
              callId: this.contact.callId,
              tabulacaoTipo: "INSUCESSO",
              tabulacao: "AGENDAMENTO",
              pf: this.agenda.tipo === 'PF'
            };

            scheduleService
              .save(agenda)
              .then(result => {
                this.contactOnFinish();
                this._clearFormSchedule();

                this.$message({
                  showClose: true,
                  message: "Agendamento realizado com sucesso.",
                  type: "success"
                });
              })
              .catch(err => console.log(err));
          })
          .catch(() => {});
      } catch (err) {
        this.$message({ showClose: true, message: err.message, type: "error" });
      }
    },

    tabularTelefone({ telefoneId, tabulacaoId, tabulacaoMotivoId, tipoTabulacao }) {
      this.contact.tabulacao = tabulacaoId
      this.contact.tabulacaoTipo = tipoTabulacao
      this.contact.uso = tipoTabulacao === "TELEFONIA" ? 8 : 9
      this.contatoTabulado = true

      this.contact.telefones = this.contact.telefones.map(tel => {
        if (tel.id == telefoneId) {
          tel.tabulacao = tabulacaoId
          this.contact.telefone = `${tel.ddd}${tel.telefone}`

          bilhetagemController.add({
            mailingId: this.contact.mailingId,
            id: this.contact.id,
            telefone: this.contact.telefone,
            tabulacaoTipo: tipoTabulacao,
            tabulacaoId: tabulacaoId,
            tabulacaoMotivoId: tabulacaoMotivoId || null,
            queue: this.contact.queue,
            callId: this.contact.callId,
            fonte: this.contact.fonte
          })
        }
        return tel
      });
    },

    // TODO mudar aqui
    onClickListenerRefused(finish = false) {
      try {
        if (!this.tabulacao.tabulacao.id || this.tabulacao.tabulacao.id === 0) return false

        if(this.tabulacao.tabulacao.motivos.length > 0 && !this.tabulacao.motivo)
          throw new Error(`Tabulação requer ${this.hasProvidencia ? 'Providência' : 'Motivo'}`)

        let objTabulacao = this.tabulacao.tabulacao;
        let message = `Confirmar o resultado ${objTabulacao.tabulacao} para o Telefone ${this.from}?`;

        this.$confirm(message, "Tabular Contato", { confirmButtonText: "Confirmar", cancelButtonText: "Cancelar" })
          .then(() => {
            this.tabularTelefone({
              telefoneId: this.telefoneId,
              tabulacaoId: objTabulacao.id,
              tabulacaoMotivoId: this.tabulacao.motivo,
              tipoTabulacao: objTabulacao.tipo
            });

            this.tabulacao.tabulacao = {}
            this.tabulacao.motivo = null
          })
          .catch(err => {
            this.tabulacao.tabulacao = {}
            this.tabulacao.motivo = null
          });
      } catch(err){
        this.$alert(err.message, "Finalizar Contato", { confirmButtonText: "OK" })
      }
    },

    onClickListenerFinishContact() {
      try{

        if(this.tabulacao.tabulacao.id){
          if(this.tabulacao.tabulacao.motivos.length > 0 && !this.tabulacao.motivo)
            throw new Error(`Tabulação requer ${this.hasProvidencia ? 'Providência' : 'Motivo'}`)

        if(this.hasRecebeuRevista){
          if((this.tabulacao.tabulacao.tipo !== 'TELEFONIA' && !this.tabulacao.tabulacao.idt)){
            if(!this.contact.recebeuRevista)
              throw new Error(`Informe antes se Recebeu Revista.`)
          }
        }

          if(!this.contatoTabulado)
            this.tabularTelefone({
              telefoneId: this.telefoneId,
              tabulacaoId: this.tabulacao.tabulacao.id,
              tabulacaoMotivoId: this.tabulacao.motivo,
              tipoTabulacao: this.tabulacao.tabulacao.tipo
            })
        }

        if(!this.contatoTabulado) throw new Error("Efetue a tabulação do contato antes de prosseguir")

        if (!this.ligacaoFoiFinalizada()) return false;

        let contact = JSON.parse(JSON.stringify(this.contact))
        delete contact.mailing

        if(this.getUser.tipoDiscagem !== "PREDITIVO") contact.repasses += 1

        this.loading = true
        // this.contact.receberInformativo = this.mail.receberInformativo
        contactService.finish(contact)
          .then(result => {
            this.loading = false
            if (contact.isAgenda) this.fetchSchedules();
            if(this.contact.receberInformativo && !this.emailHasSend) this.onClickSendMail(contact.email)
            this.contactOnFinish();
          })
          .catch(err => {
            this.loading = false
            this.$notify({
              title: "Falha de comunicação.",
              message: "Ocorreu uma falha ao finalizar o contato. Por favor, informe ao supervisor.",
              type: "error",
              offset: 20
            });
            console.log(err);
          });
      } catch(err) {
        this.$alert(err.message, "Finalizar Contato", { confirmButtonText: "OK" });
      }
    },

    contactOnFinish() {
      this.contatoTabulado = true;
      this.rediscagem = false;

      this.$store.commit("removeContact", this.contact.id);
      bilhetagemController.save();
      this.contact = {};

      this.$store.commit('SET_RECEBER_INFORMATIVO', this.showDisplaySendMail)
      this.$store.commit('SET_MAIL_SEND', false)
      this.receberInformativo = this.showDisplaySendMail

      this.emailLoading = false

      this.tabulacao.tabulacao = {}
      this.tabulacao.motivo = null;

      this._clearFormSchedule();
      this._clearFormaTratamento()

      if (this.contacts.length > 0) {
        this.loadDataAndCall(this.contacts[0], false, false);
      } else {
        this.$bus.$emit("doUnPause", { condition: 9 });
        this.nextContact();
      }

      this.$bus.$emit("updateHeader", {});
    },

    ligacaoFoiFinalizada() {
      if (this.ligacaoEmCurso) {
        this.$alert("Não é possível finalizar o contato com a chamada em curso.", "Finalize a Chamada", { confirmButtonText: "OK" });

        return false;
      }
      return true;
    },

    pauseToTabuled(showMessage = false) {
      if (this.getUser.tipoDiscagem === "PREDITIVO") {
        if (this.contact.id && !this.contatoTabulado && !this.rediscagem) {
          this.$bus.$emit("doPause", { pause: 9 });

          if (showMessage) {
            this.$message({
              showClose: true,
              message: "Finalize o contato antes de prosseguir.",
              type: "error"
            });
          }
        }
        this.rediscagem = false;
      }
    },

    hideModal(modal) {
      this._onClickHideModal(modal.name);
    },

    onEventListenerPABX(event) {
      console.log("%c" + JSON.stringify(event), "color:white; background:gray; padding:4px; border-radius:4px; font-size:1em");

      switch (event.eventName) {
        case "onConnect":
          this.onStartApplication = true;
          break;
        case "onLogin":
        case "onUnpause":
          if (this.contact.id || this.hasContact) {
            if (!this.contact.id && this.hasContact) this.reloadData();
            this.pauseToTabuled(true);
          } else {
            this.nextContact();
          }
          break;
        case "onStatus":
          if (this.onStartApplication && this.hasContact) {
            this.reloadData();
            this.pauseToTabuled(true);
          }
          if (event.status === "ONTHEPHONE" && !this.ligacaoEmCurso) {
            this.from = event.statusData.call_number;
            const { call_action_id } = event.statusData || {}
            this.fromId = call_action_id || 0

            this.contatoTabulado = false;
            this.ligacaoEmCurso = true;

            this.lastQueue = event.statusData.call_queue;
            this.lastCallId = event.statusData.call_id;

            if(!this._phoneHasExistsInContacts(this.from))
              if(!call_action_id){
                this.fetchContact(this.from).then(data => {
                  data.tipoLigacao = 'MANUAL'
                  this.loadDataAndCall(data, false, false)
                })
              } else {
                this.fetchContactById(call_action_id).then(data => {
                  data.tipoLigacao = 'PREDITIVA'
                  this.loadDataAndCall(data, false, false)
                })
              }
          }

          let whenRefreshPage = event.status === "ONLINE" && this.onStartApplication;

          if (whenRefreshPage) this.nextContact();

          this.onStartApplication = false;
          break;
        case "onDial":
          if (!this.ligacaoEmCurso) {
            this.from = event.to;
            this.contatoTabulado = false;
            this.ligacaoEmCurso = true;

            this.lastQueue = event.queue;
            this.lastCallId = event.callId;

            if (this.contact.Id) {
              this.contact.queue = this.lastQueue || "";
              this.contact.callId = this.lastCallId || "";

              this.addTelefoneToContact(this.from);
            } else {
              this.fetchContact(this.from).then(data =>
                this.loadDataAndCall(data, false, false)
              );
            }
          } else {
            this.$bus.$emit("doHangUp", event);
          }
          break;
        case "onReceive":
          this.from = event.from;
          this.fromId = event.actionId || 0
          if(/-/.test(String(this.fromId))) this.fromId = 0

          if (!this.ligacaoEmCurso) {
            this.lastQueue = event.queue;
          }
          break;
        case "onDialAnswer":
        case "onReceiveAnswer":
          if ((this.ligacaoEmCurso || this.contact.Id) && !this._phoneHasExistsInContacts(this.from) ) {
            if(this.fromId) {
              this.fetchContactById(this.fromId).then(contact => this.$store.commit("addContact", contact))
            } else {
              this.fetchContact(this.from).then(contact => this.$store.commit("addContact", contact))
            }
          } else {
            this.lastCallId = event.callId;

            if(this.fromId){
              this.fetchContactById(this.fromId)
                .then(data => {
                  data.tipoLigacao = 'PREDITIVA'
                  this.loadDataAndCall(data, false, false)
                });
            } else {
              this.fetchContact(this.from).then(data => {
                data.tipoLigacao = 'RECEPTIVA'
                this.loadDataAndCall(data, false, false)
              });
            }

            this.ligacaoEmCurso = true;
            this.fromId = 0
          }
          break;
        case "onHangUp":
        case "onDialFailure":
          this.rediscagem = false;

          this.pauseToTabuled();

          callidLogService.save({
            contatoId: this.contact.id || 0,
            pabx: this.$store.state.pabx.name,
            pabxCallid: event.callId
          });

          this.ligacaoEmCurso = false;
          break;
        case "onError":
          this.ligacaoEmCurso = false;
          break;
      }
    }
  }
};
</script>
<style scoped>
.top {
  top: 10px;
}
</style>



// WEBPACK FOOTER //
// Operacional.vue?1769de88